import { render, staticRenderFns } from "./BoxeWinEdit.vue?vue&type=template&id=8a0fab30&scoped=true&"
import script from "./BoxeWinEdit.vue?vue&type=script&lang=js&"
export * from "./BoxeWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoxeWinEdit.vue?vue&type=style&index=0&id=8a0fab30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0fab30",
  null
  
)

export default component.exports